<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();
const expanded = ref(true);
const total = computed(() =>
  props.rows.reduce((sum, item) => sum + item.contador_escrituras, 0)
);
const largestValue = computed(() =>
  Math.max(...props.rows.map(item => item.contador_escrituras), 1)
);
const spanClasses = [
  '',
  'col-span-1',
  'col-span-2',
  'col-span-3',
  'col-span-4',
  'col-span-5',
  'col-span-6',
  'col-span-7',
  'col-span-8',
  'col-span-9',
  'col-span-10',
  'col-span-11',
  'col-span-12',
];
const barSpan = value =>
  spanClasses[Math.max(1, Math.ceil((value / largestValue.value) * 12))];
</script>

<template>
  <LaisCard :title="t('POST_SALE.MANAGEMENT.DEEDS_TOTAL_TITLE')">
    <template #titleAction>
      <LaisPrimaryButton
        variant="ghost"
        :icon="expanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        @click="expanded = !expanded"
      >
        {{
          expanded
            ? t('POST_SALE.MANAGEMENT.DEEDS_HIDE_CHART')
            : t('POST_SALE.MANAGEMENT.DEEDS_SHOW_CHART')
        }}
      </LaisPrimaryButton>
    </template>

    <div
      v-if="loading"
      class="h-48 animate-pulse rounded-lais-sm bg-lais-bg-soft"
    />
    <div v-else-if="expanded" class="flex flex-col gap-4">
      <p class="text-3xl font-semibold text-lais-text">{{ total }}</p>
      <div v-if="rows.length" class="flex flex-col gap-3">
        <div
          v-for="item in rows"
          :key="item.responsavel_id"
          class="grid grid-cols-[minmax(8rem,1fr)_minmax(12rem,2fr)_2rem] items-center gap-3 text-sm"
        >
          <span class="truncate font-medium text-lais-text-body">
            {{ item.nome_responsavel }}
          </span>
          <div class="grid grid-cols-12 rounded-full bg-lais-bg-soft p-0.5">
            <span
              class="h-3 rounded-full bg-lais-primary"
              :class="barSpan(item.contador_escrituras)"
            />
          </div>
          <strong class="text-right text-lais-text">
            {{ item.contador_escrituras }}
          </strong>
        </div>
      </div>
      <p v-else class="text-sm text-lais-text-muted">
        {{ t('POST_SALE.EMPTY.DEEDS') }}
      </p>
    </div>

    <template #footer>
      <p class="text-sm font-medium text-lais-text-body">
        {{ t('POST_SALE.MANAGEMENT.CHART.TOTAL', { count: total }) }}
      </p>
    </template>
  </LaisCard>
</template>
